import React, { useState, useEffect } from 'react';
import './Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faInstagram, faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import CIR1 from './images/CIR1.png';
import White from './images/white.png';
import image2 from './images/reno3.png';
import image3 from './images/header-pic.svg';
import image4 from './images/Online consulting-bro 1.svg';

// Import your six images here
import nano1 from './images/nano.png';
import nano2 from './images/nano2.png';
import nano3 from './images/nano4.svg';
import nano4 from './images/nano3.svg';
import nano5 from './images/nano5.svg';
import nano6 from './images/nano6.png';

const images = [image2, image3, image4, nano1, nano2, nano3, nano4, nano5, nano6]; // Combined array of images

const Home = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3500); // Change image every 3.5 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="home-container">
            <div className="text-container">
                <h1 className="heading">
                    UnLock.....<br />
                    <span className='hi'>
                        <span className='letter' style={{ color: '#f28b82' }}>D</span>
                        <span className='letter' style={{ color: '#fbbc04' }}>e</span>
                        <span className='letter' style={{ color: '#fff475' }}>v</span>
                        <span className='letter' style={{ color: '#ccff90' }}>O</span>
                        <span className='letter' style={{ color: '#a7ffeb' }}>p</span>
                        <span className='letter' style={{ color: '#d7aefb' }}>s</span>
                    </span>
                    <br /> Your Guide to<br /> Streamlined <br />Development
                </h1>
                
                <button className="acbutton">
                    <Link to="/login" className="tt">Get's Started!!</Link>
                    <FontAwesomeIcon icon={faTelegram} className="icon" />
                </button>
            </div>
            <div className="image-container">
                <div className="imagescroll">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Image ${index + 1}`}
                            style={{ opacity: currentIndex === index ? 1 : 0 }}
                        />
                    ))}
                    {/* Updated group image with a class */}
                    <img src={image2} alt="Group Image" className="group-image" />
                </div>
            </div>
            <div>
                <p className="set">
                    <FontAwesomeIcon icon={faInstagram} />
                    <FontAwesomeIcon icon={faTwitter} />
                    <FontAwesomeIcon icon={faFacebook} />
                </p>
            </div>
            <img src={CIR1} className="circle p" alt="Circle 1" />
            <img src={CIR1} className="circle we" alt="Circle 2" />
            <img src={CIR1} className="circle uu" alt="Circle 3" />
            <img src={White} className="circle wh" alt="Circle 4" />
            <div className="circle ur"></div>
            <img src={CIR1} className="circle urr" alt="Circle 5" />
        </div>
    );
}

export default Home;
